export default {
  unitOfMeasureCode: { field: 'code' },
  unitOfMeasureID: { field: 'unitOfMeasureId' },
  unitOfMeasureName: { field: 'unitOfMeasureName' }
};
